import { createSlice } from '@reduxjs/toolkit';

export enum RequestStatus {
    FETCHING,
    SUCCESS,
    ERROR,
}

export interface IRequestState<T = any> {
    status?: RequestStatus;
    data?: T;
    error?: string;
    code?: number;
    abortRequest?: any;
    variables?: any;
}

export const initialState: IRequestState = {};

export const requestSlice = createSlice({
    name: 'request',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        makeRequest: (state, action) => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        abortRequest: (state, action) => {},
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setRequestCode: (state, action) => {
            state.code = action.payload;
        },
        resetStoreData: (state, action) => {},
        setVariables: (state, action) => {
            state.variables = action.payload;
        },
    },
});

export const { resetStoreData } = requestSlice.actions;
export const requestSelectors = {
    getRequest: (state: IRequestState) => state,
};
